module.exports = require('./helpers/bundle-url').getBundleURL('bu0dN') + "be1d80cfd8008_003.2bbef90a.png";